import React from "react"
import { useTranslation } from "react-i18next"
import PPMatchingProductImage from "./PPMatchingProductImage"
import PPMatchingProductFacts from "./PPMatchingProductFacts"

export default function PPMatchingMasterCard({ master, priceLang, onRejectAllCandidates, rejecting }) {
    const [t] = useTranslation()

    if (!master) {
        return null
    }

    return (
        <div className="pp-matching-master-card">
            <div className="pp-matching-card-row">
                <PPMatchingProductImage imageUrl={master.imageUrl} className="pp-matching-product-img--master" />
                <div className="pp-matching-card-row__content">
                    <PPMatchingProductFacts product={master} isMaster priceLang={priceLang} />
                </div>
                <div className="pp-matching-card-row__actions">
                    <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={onRejectAllCandidates}
                        disabled={rejecting}
                        title={t("matching.reject_all_candidates_hint")}
                    >
                        <i className="fas fa-times-circle me-1" />
                        {rejecting ? t("matching.rejecting") : t("matching.reject_all_candidates")}
                    </button>
                </div>
            </div>
        </div>
    )
}
